"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteRFQ = exports.revokeRFQ = exports.getRFQReducer = void 0;
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var doesObjHaveUndefinedValues_1 = __importDefault(require("common/utils/doesObjHaveUndefinedValues"));
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var app_1 = __importDefault(require("firebase/app"));
var lodash_1 = require("lodash");
var set_1 = __importDefault(require("lodash/fp/set"));
var moment_1 = __importDefault(require("moment"));
var SendNotification_1 = require("portal/utils/SendNotification");
var CBAReducer_1 = require("../CBA/CBAReducer");
var getRFQReducer = function (router, t) { return function (state, action) {
    var _a, _b, _c, _d, _e;
    var match = router.match;
    var RFQId = match.params.RFQId;
    switch (action.type) {
        case "init":
            return action.payload;
        case "setOverallTotal": {
            return __assign(__assign({}, state), { overallTotal: action.data.overallTotal });
        }
        case "update":
            if (action.payload.path.endsWith("supplier")) {
                state = (0, set_1.default)(action.payload.path + "Id", action.payload.newValue.id, state);
            }
            if (action.payload.path.includes("Address" ||
                "Website" ||
                "Email" ||
                "ContactName" ||
                "ContactNumber" ||
                "Tel")) {
                state = (0, set_1.default)(action.payload.path, action.payload.newValue.state, state);
            }
            if (action.payload.path === "RFQDate") {
                console.log("IR Date", (_a = state === null || state === void 0 ? void 0 : state.irData) === null || _a === void 0 ? void 0 : _a.IRDate);
                if (((_b = state === null || state === void 0 ? void 0 : state.irData) === null || _b === void 0 ? void 0 : _b.IRDate) != undefined) {
                    var isBefore = (_c = (0, moment_1.default)(action.payload.newValue)) === null || _c === void 0 ? void 0 : _c.isBefore((_d = state.irData.IRDate) === null || _d === void 0 ? void 0 : _d.toDate());
                    // console.log(action.payload.newValue,"-->",  state?.irData?.IRDate, "--->", isBefore)
                    if (isBefore === true) {
                        antd_1.message.error("RFQ Date can not be before IR Date");
                    }
                    var newDate = isBefore
                        ? (_e = state === null || state === void 0 ? void 0 : state.irData) === null || _e === void 0 ? void 0 : _e.IRDate
                        : action.payload.newValue;
                    return (0, set_1.default)(action.payload.path, newDate, state);
                }
                else {
                    // console.log(action.payload.newValue,"-->")
                    var newDate = action.payload.newValue;
                    return (0, set_1.default)(action.payload.path, newDate, state);
                }
            }
            return (0, set_1.default)(action.payload.path, action.payload.newValue, state);
        case "buttonClick":
            switch (action.data.action) {
                case "Save": {
                    var data_1 = getRFQDataFromState(state);
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            transaction.set(collectionsRef_1.RFQsRef.doc(state.RFQId), (0, removeUndefined_1.default)(__assign({}, data_1)));
                            state.RFQItems.map(function (RFQItem) { return __awaiter(void 0, void 0, void 0, function () {
                                var productType, itemData;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, collectionsRef_1.productsRef.doc(RFQItem.productId).get()];
                                        case 1:
                                            productType = (_a = (_b.sent()).data()) === null || _a === void 0 ? void 0 : _a.productType;
                                            itemData = getRFQItemFromState(state, RFQItem);
                                            collectionsRef_1.RFQItemsRef.doc(RFQItem.id).update(__assign(__assign({}, (0, removeUndefined_1.default)(itemData)), { productType: productType }));
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                            return [2 /*return*/];
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            antd_1.message.success("Saved Successfully");
                            return [2 /*return*/];
                        });
                    }); })
                        .catch(function (e) {
                        console.error(e);
                        antd_1.message.error(t("alerts.error"));
                    });
                    break;
                }
                case "Cancel": {
                    collectionsRef_1.RFQsRef.doc(state.RFQId)
                        .update({ status: "cancelled" })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        officeId: state.officeId,
                                        projectId: state.projectId,
                                        docType: "request-for-quotation",
                                        docId: RFQId,
                                        ref: (_a = state.RFQNo) !== null && _a !== void 0 ? _a : "",
                                        docDesc: state.formDescription,
                                        action: "cancelled",
                                    })];
                                case 1:
                                    _b.sent();
                                    antd_1.message.success(t("alerts.success"));
                                    window.location.reload();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    break;
                }
                case "Revoke": {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, (0, exports.revokeRFQ)(RFQId, state.orderId, transaction)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        officeId: state.officeId,
                                        projectId: state.projectId,
                                        docType: "request-for-quotation",
                                        docId: RFQId,
                                        ref: (_a = state.RFQNo) !== null && _a !== void 0 ? _a : "",
                                        docDesc: state.formDescription,
                                        action: "revoked",
                                    })];
                                case 1:
                                    _b.sent();
                                    antd_1.message.success(t("alerts.success"));
                                    window.location.reload();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .catch(function (e) {
                        antd_1.message.error(e);
                    });
                    break;
                }
                case "Publish": {
                    var isValid_1 = true;
                    var RFQData_1 = getRFQDataFromState(state);
                    console.log({ RFQData: RFQData_1 });
                    if ((0, doesObjHaveUndefinedValues_1.default)(RFQData_1)) {
                        console.log("here 1");
                        isValid_1 = false;
                        antd_1.message.error(t("alerts.invalidFormMsg"));
                        return __assign(__assign({}, state), { triedSubmitting: true });
                    }
                    state.RFQItems.map(function (RFQItem) {
                        var itemData = getRFQItemFromState(state, RFQItem);
                        console.log({ itemData: itemData });
                        if ((0, doesObjHaveUndefinedValues_1.default)(itemData)) {
                            console.log("here 2");
                            isValid_1 = false;
                            antd_1.message.error(t("alerts.invalidFormMsg"));
                            return __assign(__assign({}, RFQItem), { triedSubmitting: true });
                        }
                    });
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var existingSuppliers, RFQSupplier;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, collectionsRef_1.RFQsRef.where("supplierId", "==", RFQData_1.supplierId)
                                        .where("orderId", "==", RFQData_1.orderId)
                                        .get()];
                                case 1:
                                    existingSuppliers = _b.sent();
                                    RFQSupplier = existingSuppliers.docs.filter(function (x) { var _a; return x.id !== state.RFQId && ((_a = x.data()) === null || _a === void 0 ? void 0 : _a.status) === "approved"; }).length;
                                    if (RFQSupplier > 0) {
                                        isValid_1 = false;
                                        antd_1.message.error("RFQ already exists for this supplier");
                                        return [2 /*return*/, __assign(__assign({}, state.supplier), { triedSubmitting: true })];
                                    }
                                    if (!(0, doesObjHaveUndefinedValues_1.default)(RFQData_1)) {
                                        isValid_1 = true;
                                        transaction.update(collectionsRef_1.RFQsRef.doc(state.RFQId), __assign({}, (0, removeUndefined_1.default)(RFQData_1)));
                                    }
                                    // state.RFQItems.map(RFQItem => {
                                    //     const itemData = getRFQItemFromState(state, RFQItem)
                                    //     if (doesObjHaveUndefinedValues(itemData)) {
                                    //         isValid = false
                                    //         message.error(t('alerts.invalidFormMsg'))
                                    //         return { ...RFQItem, triedSubmitting: true }
                                    //     }
                                    // })
                                    state.RFQItems.map(function (item) {
                                        var data = getRFQItemFromState(state, item);
                                        if ((0, doesObjHaveUndefinedValues_1.default)(data)) {
                                            isValid_1 = false;
                                        }
                                        else {
                                            transaction.set(collectionsRef_1.RFQItemsRef.doc(item.id), __assign(__assign({}, data), { index: item.index }));
                                        }
                                    });
                                    if (!isValid_1) return [3 /*break*/, 3];
                                    transaction.update(collectionsRef_1.ordersRef.doc(RFQData_1.orderId), {
                                        status: "preparingCBA",
                                    });
                                    transaction.update(collectionsRef_1.RFQsRef.doc(state.RFQId), {
                                        requestedAt: new Date(),
                                        requestedBy: app_1.default.auth().currentUser.uid,
                                        status: "approved",
                                    });
                                    return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                            officeId: state.officeId,
                                            projectId: state.projectId,
                                            docType: "request-for-quotation",
                                            docId: RFQId,
                                            ref: (_a = state.RFQNo) !== null && _a !== void 0 ? _a : "",
                                            docDesc: state.formDescription,
                                            action: "approved",
                                        })];
                                case 2:
                                    _b.sent();
                                    _b.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        if (isValid_1) {
                            antd_1.message.success(t("alerts.success"));
                            window.location.reload();
                        }
                    })
                        .catch(function (e) {
                        if (e.message === "FormNotValid") {
                            antd_1.message.error(t("alerts.invalidFormMsg"));
                        }
                        else {
                            console.error(e);
                            antd_1.message.error(t("alerts.error"));
                        }
                    });
                    break;
                }
            }
    }
    return state;
}; };
exports.getRFQReducer = getRFQReducer;
var getRFQDataFromState = function (state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var total = (0, lodash_1.sumBy)(state.RFQItems, function (item) { return item.quantity * item.unitPrice; });
    return {
        orderId: state.orderId,
        status: state.status,
        RFQNo: state.RFQNo,
        projectId: state.projectId,
        projectsIds: state.projectsIds,
        exchangeRate: state.exchangeRate,
        total: total,
        budgetLineId: state.budgetLineId,
        idaApprovalUser: state.idaApprovalUser,
        supplierApprovalUser: state === null || state === void 0 ? void 0 : state.supplierApprovalUser,
        supplierContactName: (_a = state.supplier) === null || _a === void 0 ? void 0 : _a.contactPerson,
        supplierContactNumber: (_b = state.supplier) === null || _b === void 0 ? void 0 : _b.companyNumber,
        supplierTel: (_c = state.supplier) === null || _c === void 0 ? void 0 : _c.mobilePhone,
        supplierWebsite: (_d = state.supplier) === null || _d === void 0 ? void 0 : _d.website,
        supplierEmail: (_e = state.supplier) === null || _e === void 0 ? void 0 : _e.email,
        supplierName: (_f = state.supplier) === null || _f === void 0 ? void 0 : _f.companyName,
        supplierAddress: (_g = state.supplier) === null || _g === void 0 ? void 0 : _g.physicalAddress,
        deliveryPlace: state.deliveryPlace,
        formDescription: state.formDescription,
        irId: state.irId,
        shippingCosts: state.shippingCosts === 0 ? "included" : state.shippingCosts,
        supplierId: state.supplierId,
        taxes: state.taxes === 0 ? "included" : state.taxes,
        overallTotal: state.overallTotal,
        RFQDate: (_j = (_h = state.RFQDate) === null || _h === void 0 ? void 0 : _h.toDate()) !== null && _j !== void 0 ? _j : null,
        currencyId: state.currencyId,
        termsOfPayment: "",
        deliveryTerms: (_k = state.deliveryTerms) !== null && _k !== void 0 ? _k : "",
        deliveryDate: (_l = state.deliveryDate) !== null && _l !== void 0 ? _l : "",
        quotationValidity: (_m = state.quotationValidity) !== null && _m !== void 0 ? _m : "",
        idaApprovalDate: (_p = (_o = state.idaApprovalDate) === null || _o === void 0 ? void 0 : _o.toDate()) !== null && _p !== void 0 ? _p : null,
        supplierApprovalDate: (_r = (_q = state.supplierApprovalDate) === null || _q === void 0 ? void 0 : _q.toDate()) !== null && _r !== void 0 ? _r : null,
        otherInformation: (_s = state.otherInformation) !== null && _s !== void 0 ? _s : "",
        byBank: (_t = state.byBank) !== null && _t !== void 0 ? _t : "no",
        byCash: (_u = state.byCash) !== null && _u !== void 0 ? _u : "no",
    };
};
var getRFQItemFromState = function (state, RFQItem) {
    var _a, _b, _c;
    return {
        IRItemId: RFQItem.IRItemId,
        RFQId: state.RFQId,
        orderId: RFQItem.orderId,
        itemDescription: RFQItem.itemDescription,
        quantity: RFQItem.quantity,
        total: RFQItem.quantity * RFQItem.unitPrice,
        unitPrice: RFQItem.unitPrice,
        unitId: RFQItem.unitId,
        offeredItem: RFQItem.offeredItem,
        budgetLineId: RFQItem === null || RFQItem === void 0 ? void 0 : RFQItem.budgetLineId,
        budgetLinesIds: RFQItem === null || RFQItem === void 0 ? void 0 : RFQItem.budgetLinesIds,
        budgetLinesPercentages: RFQItem === null || RFQItem === void 0 ? void 0 : RFQItem.budgetLinesPercentages,
        // brand: RFQItem.brand,
        originCountry: (_a = RFQItem.originCountry) !== null && _a !== void 0 ? _a : "",
        warranty: (_b = RFQItem.warranty) !== null && _b !== void 0 ? _b : "",
        expiryDate: (_c = RFQItem.expiryDate) !== null && _c !== void 0 ? _c : "",
        productId: RFQItem.productId,
        supplierId: state.supplierId,
        productName: RFQItem.productName,
    };
};
var revokeRFQ = function (RFQId, orderId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var CBAs, itemsReceived, someCompleted;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, collectionsRef_1.CBAsRef.where("RFQsIds", "array-contains-any", [RFQId]).get()];
            case 1:
                CBAs = (_b = (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.docs) !== null && _b !== void 0 ? _b : [];
                return [4 /*yield*/, collectionsRef_1.DNsRef.where("orderId", "==", orderId).get()];
            case 2:
                itemsReceived = (_c.sent())
                    .docs.length;
                someCompleted = CBAs.some(function (x) {
                    var data = x.data();
                    return data.status === "singedAndArchived" || data.status === "completed";
                });
                if (someCompleted) {
                    throw new Error("you cannot revoke singed form");
                }
                if (itemsReceived) {
                    antd_1.message.error("This RFQ has Delivery Note and cannot be revoked");
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Promise.all(CBAs.map(function (CBAId) { return (0, CBAReducer_1.deleteCBA)(CBAId.id, orderId, transaction); }))];
            case 3:
                _c.sent();
                transaction.update(collectionsRef_1.ordersRef.doc(orderId), { status: "preparingRFQs" }),
                    transaction.update(collectionsRef_1.RFQsRef.doc(RFQId), {
                        status: "draft",
                    });
                return [2 /*return*/];
        }
    });
}); };
exports.revokeRFQ = revokeRFQ;
var deleteRFQ = function (RFQId, orderId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var data, _a, _b;
    var _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, transaction.get(collectionsRef_1.RFQsRef.doc(RFQId))];
            case 1:
                data = (_c = (_e.sent())) === null || _c === void 0 ? void 0 : _c.data();
                if (data.status === "completed") {
                    throw new Error("you cannot delete completed RFQ");
                }
                if (!(data.status === "pendingApprovals" ||
                    data.status === "approved" ||
                    data.status === "singedAndArchived")) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, exports.revokeRFQ)(RFQId, orderId, transaction)];
            case 2:
                _e.sent();
                _e.label = 3;
            case 3:
                transaction.delete(collectionsRef_1.RFQsRef.doc(RFQId));
                _b = (_a = Promise).all;
                return [4 /*yield*/, collectionsRef_1.RFQItemsRef.where("RFQId", "==", RFQId).get()];
            case 4: return [4 /*yield*/, _b.apply(_a, [(_d = (_e.sent())) === null || _d === void 0 ? void 0 : _d.docs.map(function (x) {
                        return transaction.delete(x.ref);
                    })])];
            case 5:
                _e.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.deleteRFQ = deleteRFQ;
